/**
 * HTML 태그를 제거하고 순수 텍스트만 반환
 * @param html - HTML 문자열
 * @param maxLength - 최대 길이 (선택사항)
 * @returns 순수 텍스트
 */
export function stripHtmlTags(html: string, maxLength?: number): string {
  if (!html) return '';

  // HTML 태그 제거
  let text = html.replace(/<[^>]*>/g, '');

  // HTML 엔티티 디코딩 (&nbsp; -> 공백 등)
  text = text
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");

  // 연속된 공백을 하나로
  text = text.replace(/\s+/g, ' ').trim();

  // 최대 길이 제한
  if (maxLength && text.length > maxLength) {
    text = text.substring(0, maxLength) + '...';
  }

  return text;
}
